import { getLocalizedDefaults } from './catalog';
import type { CanonicalToken, SupportedLanguage } from './types';
import { CANONICAL_TOKENS } from './types';

export const DYNAMIC_DATA_TOKEN_DESCRIPTIONS: Record<CanonicalToken, string> = {
  title: 'Event title',
  date: 'Date of the appointment',
  time: 'Time of the appointment',
  from: 'Your business name provided',
  location: 'Meeting location previously provided',
  eventlocation: 'Event location',
  videolink: 'Video meeting link',
};

export interface DynamicDataHelpLine {
  tokenHint: string;
  description: string;
}

export function formatTokenHint(
  token: CanonicalToken,
  language: SupportedLanguage,
): string {
  if (language === 'en') {
    return `{${token}}`;
  }

  const alias = getLocalizedDefaults(language).tokenAliases[token];
  if (!alias || alias === token) {
    return `{${token}}`;
  }

  return `{${token}/${alias}}`;
}

export function buildDynamicDataHelpLines(
  language: SupportedLanguage,
): DynamicDataHelpLine[] {
  return CANONICAL_TOKENS.map((token) => ({
    tokenHint: formatTokenHint(token, language),
    description: DYNAMIC_DATA_TOKEN_DESCRIPTIONS[token],
  }));
}
